module.exports = __webpack_public_path__ + "static/media/A18040103_10002_2.2ae7d088.jpg";